import type { PropsWithChildren } from "react";
import type { AuthorizedProps } from "./types";
import withAuthorization from "./withAuthorization";

const Authorized = ({ children }: PropsWithChildren<AuthorizedProps>) => (
    <>
        {children}
    </>
);

export default withAuthorization(Authorized);
